import { lazy } from 'react';

import PrivateRoute from '../components/PrivateRoute';
import WorkspaceRoute from '../components/WorkspaceRoute';
import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/MinimalLayout';
import DashboardLayout from '../layout/Dashboard'
import AllContents from '../pages/content/AllContents';
import CreateEntry from '../pages/entry/CreateEntry';
import UserProfile from '../pages/authentication/UserProfile';
import ContentModel from '../pages/content/ContentModel';
import MediaList from '../pages/media/MediaList';
import EditEntry from '../pages/entry/EditEntry';
import WorkspaceList from '../pages/workspace/WorkspaceList';
import CreateWorkspace from '../pages/workspace/CreateWorkspace';
import WorkspaceSettings from '../pages/workspace/WorkspaceSettings';
import Fields from '../pages/content/Fields';
import AuthGuard from './AuthGuard';
import EditorRoute from '../components/EditorRoute';
import AppStudio from '../pages/appStudio/AppStudio';
import ErrorPage from '../pages/ErrorPage';
import PromptLibrary from '../pages/promptStore/PromptLibrary';
import Template from '../pages/promptStore/Template';
import CreatePromptForm from '../pages/promptStore/CreatePromptForm';
import OauthClients from '../pages/oauthClients/OauthClients';
import Documentation from '../pages/Documentation';
import AdminRoute from '../components/AdminRoute';

const Dashboard = Loadable(lazy(() => import('../pages/Dashboard')));
const AdminConsole = Loadable(lazy(() => import('../pages/admin/AdminConsole')));

const MainRoutes = {
    path: '/',
    element:
        <DashboardLayout />,
    errorElement: <ErrorPage />,
    children: [
        {
            path: '/space',
            element: <AuthGuard> <WorkspaceList /> </AuthGuard>
        },
        {
            path: '/space/create',
            element: <AuthGuard><CreateWorkspace /></AuthGuard>
        },
        {
            path: `/:workspaceId/dashboard`,
            element: <AuthGuard><Dashboard /></AuthGuard>
        },
        {
            path: `/:workspaceId/settings`,
            element: <AuthGuard><WorkspaceRoute><WorkspaceSettings /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/:workspaceId/content-models',
            element: <AuthGuard><WorkspaceRoute><ContentModel /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/profile',
            element: <AuthGuard><UserProfile /></AuthGuard>
        },
        {
            path: '/:workspaceId/content-type/:formId',
            element: <AuthGuard><WorkspaceRoute><Fields /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/:workspaceId/entries',
            element: <AuthGuard><WorkspaceRoute><AllContents /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/:workspaceId/create-entry/:id',
            element: <AuthGuard><WorkspaceRoute><EditorRoute><CreateEntry /></EditorRoute></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/:workspaceId/edit-entry/:id',
            element: <AuthGuard><WorkspaceRoute><CreateEntry /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/:workspaceId/media-list',
            element: <AuthGuard><WorkspaceRoute><MediaList /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/apps',
            element: <AuthGuard><AppStudio /></AuthGuard>
        },
        {
            path: '/:workspaceId/prompt-library',
            element: <AuthGuard><WorkspaceRoute><PromptLibrary /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/:workspaceId/prompt/:id/template',
            element: <AuthGuard><WorkspaceRoute><Template /></WorkspaceRoute></AuthGuard>
        },
        {
            path: '/oauth-clients',
            element: <AuthGuard><OauthClients /></AuthGuard>
        },
        {
            path: '/documentation',
            element: <AuthGuard><Documentation /></AuthGuard>
        },
        {
            path: '/admin',
            element: <AuthGuard><AdminRoute><AdminConsole /></AdminRoute></AuthGuard>
        }
    ]
}
export default MainRoutes;
